import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BiLink, BiEventType } from '@wix/da-shared-react/pkg/biLogger';
import { MenuItem as MenuItemType } from '../../types';
import s from './MenuItem.scss';

export interface Props {
  menuItem: MenuItemType;
  isActive?: boolean;
  innerRef?: React.RefCallback<HTMLElement>;
  className?: string;
}

const MenuItem: React.FC<Props> = ({
  menuItem,
  isActive,
  className,
  innerRef,
}) => {
  const { t } = useTranslation();
  const { pageType, url, hasNewContent } = menuItem;

  return (
    <BiLink
      biData={{
        evid: BiEventType.CONTENT_NAVBAR_CLICK,
        link_name: pageType,
        indicator: hasNewContent ? 1 : 0,
      }}
      className={classnames(
        s['root'],
        isActive && s['active'],
        hasNewContent && s['highlighted'],
        className
      )}
      href={url}
      innerRef={innerRef}
    >
      <span className={s['nav-item']}>
        {t(`browseHeader.page.${pageType}`)}
      </span>
    </BiLink>
  );
};
MenuItem.displayName = 'MenuItem';

export default MenuItem;
